class ShareComponent extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['copy', 'send']
  }

  static get requiredExternalElements () {
    return ['trigger']
  }

  connectedCallback () {
    super.connectedCallback()

    this.urlToShare = document.location.href
    this.emailSubject = this.getAttribute('data-email-subject')
  }

  setupListeners () {
    super.setupListeners()

    if (navigator.share) {
      this.listeners.add(this.externalEls.trigger.element, 'click', () => {
        navigator.share({
          url: this.urlToShare,
          title: document.title,
        })
      })
    } else {
      this.onToggle = this.onToggle.bind(this)
      this.listeners.add(
        this.externalEls.trigger.element,
        'click',
        this.onToggle,
      )

      this.copyToClipboard = this.copyToClipboard.bind(this)
      this.listeners.add(this.els.copy.element, 'click', this.copyToClipboard)

      this.sendEmail = this.sendEmail.bind(this)
      this.listeners.add(this.els.send.element, 'click', this.sendEmail)
    }
  }

  onToggle () {
    this.els.copy.element.innerHTML = this.els.copy.element.getAttribute(
      'reset-label',
    )
    this.dispatchEvent(
      new CustomEvent('site-modal:open', {
        bubbles: true,
        detail: { id: 'drop-a-hint' },
      }),
    )
  }

  copyToClipboard () {
    navigator.clipboard.writeText(this.urlToShare)
    this.els.copy.element.innerHTML = this.els.copy.element.getAttribute(
      'actioned-label',
    )
  }

  sendEmail () {
    window.open(`mailto:?subject=${this.emailSubject}&body=${this.urlToShare}`)
  }

  updateUrl (url) {
    this.urlToShare = url
  }
}

customElements.define('share-component', ShareComponent, { extends: 'aside' })
